import { ObjectUpdates } from "@/components/features/matter/updates/ObjectUpdates";
import { Text } from "@/components/ui";
import { useRedirectIfMatterDeleted } from "@/hooks/useRedirectIfMatterDeleted";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/matters/$matterId/_layout/updates",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { matterId } = Route.useParams();
  const { data: matterDetails } = useSuspenseQuery(
    retrieveMatterQueryOptions(matterId),
  );
  const matter = matterDetails.data;
  const isDeletedMatter = Array.isArray(matter) || !matter.id;
  useRedirectIfMatterDeleted({ matterId, isDeletedMatter });
  if (isDeletedMatter) return null;

  return (
    <div className="flex h-full min-h-0 w-full flex-col gap-y-4 p-6">
      <Text variant="title">Updates</Text>
      <div className="flex min-h-0 flex-1 flex-col">
        <ObjectUpdates anchorObjectType="matter" anchorObjectId={matterId} />
      </div>
    </div>
  );
}
